// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-access-text[data-v-c0c833ca] {\n  text-align: center;\n  padding: 20px;\n}", "",{"version":3,"sources":["webpack://./resources/js/layouts/Admin.vue"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,aAAA;AAAF","sourcesContent":["\n.no-access-text{\n  text-align: center;\n  padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
